// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1Neu5","spin":"Spinner_spin__2cA5G"};